
































import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import Banner from '@/components/Banner.vue';
import Tile from '@/components/Tile.vue';
import ProjectList from '@/components/projects/ProjectList.vue';
import EmploymentList from '@/components/employment/EmploymentList.vue';
import Education from '@/components/education/Education.vue';
import CodeList from '@/components/code/CodeList.vue';
import Contact from '@/components/Contact.vue';
import Styly from '@/components/Styly.vue';

@Component({
  components: {
    HelloWorld,
    Banner,
    Tile,
    ProjectList,
    EmploymentList,
    Education,
    CodeList,
    Contact,
    Styly
  },
})
export default class Home extends Vue {

  get leftContact(){
    return this.$store.state.leftContact;
  }

  get rightContact(){
    return this.$store.state.rightContact;
  }
}
